import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d1e2022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "suc-dialog pb-0" }
const _hoisted_2 = { class: "title text-black fw-semibold mx-4" }
const _hoisted_3 = { class: "des mx-4 mt-3" }
const _hoisted_4 = { class: "des mx-4 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.local.external_links_dialog_title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString($setup.local.external_links_dialog_des1), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString($setup.local.external_links_dialog_des2), 1),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.hide_ && $setup.hide_(...args))),
      class: "knew-btn py-2"
    }, _toDisplayString($setup.local.my_points_38), 1)
  ]))
}